module.exports = __webpack_public_path__ + "img/module_sprav.3358f8be.jpg";